<template>
  <main-content with_go_back_bar>
    <kt-panel class="my-3">
      <form class="kt-form p-3 my-4">
        <div
            class="container p-3 pt-5 my-4 border in-border-header"
            style="padding-top: 1.5rem !important"
        >
          <kt-form-section is_first>
            <div class="section-header font-weight-bold">جزئیات قالب</div>
            <div class="col-md-12 mb-3 d-flex justify-content-center">
              <h4 class="text-dark text-left">
                {{ format.name }}
              </h4>
            </div>
            <div class="d-flex flex-wrap">
              <div
                  class="my-4 col-12 col-md-6"
                  v-for="field in format.fields"
              >
                <label class="mx-2 my-1 text-nowrap" :for="field.id + '-field'">
                  {{field.fa_name || field.name }}
                </label>
                <div class="d-flex justify-content-center align-items-center">
                  <select
                      class="form-control kt-selectpicker mx-2"
                      v-model="field.status"
                      :id="field.id + '-field'"
                      disabled
                  >
                    <option :value="null">{{'لطفا انتخاب کنید'}}</option>
                    <option
                        v-for="option in options"
                        :key="option.value"
                        :value="option.value"
                    >
                      {{option.fa_name}}
                    </option>
                  </select>
                  <div :id="'details_' + field.id" class="modal fade rtl" role="dialog">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div :id="'data_sheet_' + field.id" class="modal-body">
                          <div class="modal-header">
                            <h4 class="modal-title">جزئیات فیلد {{ field.fa_name }}</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                          </div>
                          <div class="my-3 mx-4" v-for="detail in field.details">
                            <div class="d-flex justify-content-between align-items-center">
                              <label :for="detail.id" style="text-decoration: none;"> {{ detailTypesFarsi.get(detail.type) }}</label>
                              <p>{{ detailDataVariant(detail.type, detail.data) }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between">
                    <button
                        v-if="field.details.length > 0"
                        type="button"
                        class="btn btn-info mx-1"
                        data-toggle="modal"
                        :data-target="'#details_' + field.id"
                    >
                      جزئیات
                    </button>
                    <button
                        type="button"
                        class="btn-sm btn-danger"
                        @click="removeOption(field.id)"
                        v-if="!disableChecker(field)"
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </kt-form-section>
        </div>
      </form>
    </kt-panel>
  </main-content>
</template>

<script>
import {mapGetters} from "vuex";
import mainContent from "@/components/main-content.vue";
import {fieldOptions} from "@/constants/CustomerFormatFieldOptions";
import Dialog from "@/components/elements/modal/dialog.vue";
import Input from "@/components/elements/input.vue";
import {onlineFactorService} from "@/common/api.service";
import toastr from "toastr";
import {detailDataVariant, detailTypesFarsi} from "../../constants/CustomerFormatDetailType";

export default {
  name: "FormatDetail",
  components: {
    Input,
    Dialog,
    "main-content": mainContent,
  },
  computed: {
    detailTypesFarsi() {
      return detailTypesFarsi
    },
    ...mapGetters("onlineFactor", ["format"]),
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
    options() {
      return fieldOptions
    },
    disableChecker() {
      return field => {
          return (
            field.details &&
            field.details.some(i => i.type === "disable" && i.data === true)
        );
      };
    },
  },
  methods: {
    detailDataVariant,
    removeOption(field_id) {
      if (window.confirm('آیا از انجام این عملیات مطمئن هستید؟')) {
        onlineFactorService.adminDeleteField(field_id)
            .then(response => {
              this.format.fields = this.format.fields.filter(item => item.id !== field_id)
              return this.toastr.success(response.data.message)
            })
            .catch(({response}) => {
              return this.toastr.error(response.data.message)
            })

      }
    }
  },
  mounted() {
    this.$store.dispatch('onlineFactor/showFormat', this.$route.params.hashid)
  }
}
</script>

<style scoped>

</style>